/**
 * 보고서 내용을 문장 단위로 인덱싱하는 유틸리티
 */

export interface IndexedSentence {
    seq: number;
    content: string;
}

/**
 * 마크다운 콘텐츠를 줄바꿈 기준으로 인덱싱
 * @param markdownContent - 마크다운 콘텐츠
 * @returns 인덱싱된 문장 배열
 */
export function createIndexedSentences(
    markdownContent: string
): IndexedSentence[] {
    if (!markdownContent) {
        return [];
    }

    // 줄바꿈 기준으로 분리
    const lines = markdownContent.split('\n');
    const indexedSentences: IndexedSentence[] = [];
    let seq = 1;

    for (const line of lines) {
        // 빈 줄은 제외
        const trimmedLine = line.trim();
        if (trimmedLine) {
            indexedSentences.push({
                seq,
                content: trimmedLine,
            });
            seq++;
        }
    }

    return indexedSentences;
}

/**
 * 보고서 업데이트 시 indexed_sentences 재생성
 * @param newMarkdownContent - 새로운 마크다운 콘텐츠
 * @returns 재생성된 인덱싱된 문장 배열
 */
export function regenerateIndexedSentences(
    newMarkdownContent: string
): IndexedSentence[] {
    // 기존 인덱싱을 제거하고 새로 생성
    return createIndexedSentences(newMarkdownContent);
}
